import { DEFAULT_ENVIRONMENT, DeploymentEnvironment } from '../deployment-environment';

type Config = Record<DeploymentEnvironment, Urls>;

type ResourceType =
  | 'source'
  | 'application'
  | 'quotes'
  | 'fortusMessageCounter'
  | 'waitingList'
  | 'account'
  | 'reconstructionCost'
  | 'referral'
  | 'token'
  | 'passwordless'
  | 'userAccounts'
  | 'policies'
  | 'publicApi'
  | 'userSync'
  | 'inboundLeads'
  | 'reports';

type Urls = Record<ResourceType, string>;

/** Exposes the YouSet API url for each existing resource  */
class YousetApiUrlRegistry {
  readonly urls: Urls;

  constructor() {
    // FIXME: a base class should define how to get the deployment environment. This is duplicated is mostly all config classes
    const deploymentEnvironment = process.env.DEPLOYMENT_ENVIRONMENT || DEFAULT_ENVIRONMENT;
    const config: Config = require('./url-config.json');

    this.urls = config[deploymentEnvironment];
  }
}

export const yousetApiUrlRegistry = new YousetApiUrlRegistry();
